import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import {
  NbComponentStatus,
  NbDialogRef,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";
import { ClipboardService } from "ngx-clipboard";

@Component({
  selector: "ngx-dialog-share-link",
  templateUrl: "dialog-share-link.component.html",
  styleUrls: ["dialog-share-link.component.scss"],
})
export class DialogShareLinkComponent implements OnInit {
  @Input() link: string;

  submitted = false;

  constructor(
    protected ref: NbDialogRef<DialogShareLinkComponent>,
    private clipboardApi: ClipboardService,
    private toastrService: NbToastrService,
    private router: Router
  ) {}

  ngOnInit() {}

  cancel() {
    this.ref.close();
  }

  copyLink() {
    this.clipboardApi.copyFromContent(this.link);
    this.showToast("success", "Copy", "Đã sao chép link");
  }

  openLink() {
    window.open(this.link, "_blank");
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
